import { render, staticRenderFns } from "./authentication-detail.vue?vue&type=template&id=006fac54&scoped=true&"
import script from "./authentication-detail.vue?vue&type=script&lang=js&"
export * from "./authentication-detail.vue?vue&type=script&lang=js&"
import style0 from "./authentication-detail.vue?vue&type=style&index=0&id=006fac54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006fac54",
  null
  
)

export default component.exports